import pxToRem from "theme/base/pxToRem";
import typography from "theme/base/typography";
import colors from "theme/theme-light/colors";

const tab = {
  styleOverrides: {
    root: {
      fontSize: typography.size.sm_14,
      fontWeight: typography.fw_semibold_500,
      color: colors.text.textSecondary,
      textTransform: "none",
      minHeight: pxToRem(42),
      "&.Mui-selected": {
        color: colors.text.textPrimary,
      },
    },
  },
};

export default tab;
